<template>
	<b-modal
		size="xmd"
		ref="specimen-location-tracking-modal"
		@hidden="$emit('close')"
		ok-title="Guardar"
		:title="`Tracking de Ubicación de ${specimen.plate} ${specimen.alias ? '(' + specimen.alias + ')' : ''}`"
		centered
		no-close-on-backdrop
		hide-footer
	>
		<b-table-simple>
			<b-thead class="text-center">
				<b-tr>
					<b-th>Ubicación</b-th>
					<b-th>Ubicado por</b-th>
					<b-th>Fecha</b-th>
				</b-tr>
			</b-thead>
			<b-tbody class="text-center">
				<b-tr v-for="row in rows" :key="row.id">
					<b-td>
						<div v-if="row.location_area_name && row.location_name">
							{{ formatLocationName(row.location_area_name, row.location_name) }}
						</div>
					</b-td>
					<b-td>{{ row.user_name }}</b-td>
					<b-td>
						{{ row.created_at | myGlobalDayWithHour }}
					</b-td>
				</b-tr>
				<b-tr v-if="rows.length == 0">
					<b-td colspan="3">
						<p class="mb-0">No hay registros por mostrar</p>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import SpecimenLocationService from "@/views/brain/specimens/views/location/services/specimen-location.service.js"
export default {
	props: {
		specimen: Object,
	},
	name: "SpecimenLocationTrackingModal",
	components: {},
	async mounted() {
		await this.getSpecimenTracking()
		this.toggleModal("specimen-location-tracking-modal")
	},
	data() {
		return {
			rows: [],
		}
	},

	methods: {
		formatLocationName(locationAreaName, locationName) {
			const parts = locationName.split(" ")
			if (parts.length >= 2) {
				const prefix = parts[0].substring(0, 3).toUpperCase()
				const suffix = parts[parts.length - 1]
				return `${locationAreaName.substring(0, 3).toUpperCase()}-${prefix}-${suffix}`
			}
			return locationAreaName.substring(0, 3).toUpperCase() + locationName.substring(0, 3).toUpperCase()
		},
		async getSpecimenTracking() {
			this.isPreloading()
			try {
				const { data } = await SpecimenLocationService.getSpecimenTracking(this.specimen.id)
				this.rows = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	mixins: [modalMixin],
}
</script>

<style></style>
